module.exports = __webpack_public_path__ + "img/APP.0477e2d4.png";